import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { MessageDialogCategory } from "designSystem/components/dialog/MessageDialog";
import { Box, Button, MessageDialog } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	const [open, setOpen] = useState(false);
	const [category, setCategory] = useState<MessageDialogCategory>();
	const onClose = () => setOpen(false);
	const onButton = (value?: MessageDialogCategory) => {
		setCategory(value);
		setOpen(true);
	};
	const onProgress = () => {
		onButton("progress");
		setTimeout(onClose, 2000);
	};

	return (
		<Box>
			<CssColumnGrid columns={6}>
				<Button design="primary" onClick={() => onButton("error")}>
					Error
				</Button>
				<Button design="primary" onClick={() => onButton("help")}>
					Help
				</Button>
				<Button design="primary" onClick={() => onButton("info")}>
					Info
				</Button>
				<Button design="primary" onClick={() => onProgress()}>
					Progress
				</Button>
				<Button design="primary" onClick={() => onButton("success")}>
					Success
				</Button>
				<Button design="primary" onClick={() => onButton("warn")}>
					Warn
				</Button>
				<Button design="primary" onClick={() => onButton()}>
					Custom
				</Button>
			</CssColumnGrid>
			<MessageDialog
				buttonRes={!category && "Custom"}
				category={category}
				message={`Category is ${category}`}
				onClose={onClose}
				open={open}
				title="Dialog Title"
			>
				{{
					icon: !category && (
						<AccessAlarmIcon />
					),
				}}
			</MessageDialog>
		</Box>
	);
};